import { render, staticRenderFns } from "./test-canvas.vue?vue&type=template&id=d2381584&scoped=true&"
import script from "./test-canvas.vue?vue&type=script&lang=js&"
export * from "./test-canvas.vue?vue&type=script&lang=js&"
import style0 from "./test-canvas.vue?vue&type=style&index=0&id=d2381584&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2381584",
  null
  
)

export default component.exports